import React from "react";
import { AvahanaMark } from "./avahana-mark";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  /** Show the wordmark beside the mark. Default: true. */
  wordmark?: boolean;
  /**
   * Exact mark size in px, overriding the `size` token. For fixed chrome —
   * the 64px icon rail wants 32px, which sits between `md` (26) and `lg` (36).
   * Prefer `size` everywhere else so the scale stays meaningful.
   */
  markSize?: number;
}

/**
 * The brand lockup: mark + wordmark.
 *
 * This used to swap two .webp files based on the resolved theme. It no longer
 * needs to — the mark is `currentColor`, so it inherits whatever the
 * surrounding text colour is and themes itself with zero JS. That also removes
 * the flash-of-wrong-logo on first paint and the matchMedia listener.
 *
 * The `data-brand-lockup` attribute is the hand-off target for BrandSplash:
 * the splash measures this element and flies its own copy onto it.
 */
const MARK_PX = { sm: 20, md: 26, lg: 36, xl: 128 } as const;
const TEXT = {
  sm: "text-base",
  md: "text-lg",
  lg: "text-2xl",
  xl: "text-5xl",
} as const;
const GAP = { sm: "gap-2", md: "gap-2.5", lg: "gap-3", xl: "gap-5" } as const;

export function Logo({
  className = "",
  size = "md",
  wordmark = true,
  markSize,
}: LogoProps) {
  return (
    <span
      data-brand-lockup=""
      className={`inline-flex items-center ${GAP[size]} ${className}`}
    >
      {/* data-brand-mark is the flight target for BrandSplash. The splash
          flies ONLY the mark here — the sidebar is narrow and has no room for
          the wordmark, so the wordmark fades out rather than travelling. */}
      <AvahanaMark
        data-brand-mark=""
        size={markSize ?? MARK_PX[size]}
        title={wordmark ? undefined : "Āvāhana"}
        className="shrink-0"
      />
      {wordmark && (
        <span
          className={`font-semibold tracking-tight leading-none ${TEXT[size]}`}
        >
          Āvāhana
        </span>
      )}
    </span>
  );
}
